const WOD_DIFFICULTY_GRADES = [
    {'code': 'so-easy', 'color': 'green'},
    {'code': 'easy', 'color': 'yellow'},
    {'code': 'medium', 'color': 'orange'},
    {'code': 'hard', 'color': 'orange'},
    {'code': 'impossible', 'color': 'red'},
];

export default WOD_DIFFICULTY_GRADES;


// WEBPACK FOOTER //
// ./src/shared/wod-difficulty-grades.js